import React from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import compose from 'lodash/fp/compose';
import withSetupNeeded from 'src/components/withSetupNeeded';
import * as Urls from 'src/constants/EndpointUrls';
import styles from './YearEndReport.scss';

const YearEndReport = () => {
  const { t } = useTranslation();
  return (
    <React.Fragment>
      <div className="l-main-title-wrap">
        <h1 className="m-title-main">{t('features.YearEndReports.YearEndReport.year_end_document')}</h1>
      </div>
      <div className="l-wrap-xxl l-contents-wrap">
        <div className="l-overflow-scroll">
          <table className={styles.table}>
            <thead>
              <tr>
                <th>{t('features.YearEndReports.YearEndReport.category')}</th>
                <th>{t('features.YearEndReports.YearEndReport.document_name')}</th>
                <th>{t('features.YearEndReports.YearEndReport.submission_period')}</th>
                <th>{t('features.YearEndReports.YearEndReport.detailed_description')}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className={styles.category} rowSpan={1}>
                  {t('features.YearEndReports.YearEndReport.document_for_the_revenue_office')}
                </td>
                <td className={styles.name}>
                  <a href={Urls.SHOW_TAX_DEDUCTION_CERTS_PAGE_URL}>{t('features.YearEndReports.YearEndReport.tax_deduction_cert')}</a>
                  <p>{t('features.YearEndReports.YearEndReport.a_list_of_salaries_and_withholding_taxes_paid_to_employees_during_the_year')}</p>
                </td>
                <td className={styles.limit}>
                  <p>{t('features.YearEndReports.YearEndReport.before_end_of_March')}</p>
                </td>
                <td>
                  <p>{t('features.YearEndReports.YearEndReport.you_can_check_your_payroll_and_withholding_taxes_paid_from_jan_1st_to_dec_31st')}</p>
                </td>
              </tr>
              {/* <tr>
                <td className={styles.category} rowSpan={1}>
                  {t('features.YearEndReports.YearEndReport.document_for_sso')}
                </td>
                <td className={styles.name}>
                  <a href={Urls.SHOW_KT20_KOR_PAGE_URL}>{t('features.YearEndReports.YearEndReport.kt20_kor')}</a>
                  <p>{t('features.YearEndReports.YearEndReport.a_list_of_salaries_and_allowances_paid_to_employees_during_the_year')}</p>
                </td>
                <td className={styles.limit}>
                  <p>{t('features.YearEndReports.YearEndReport.until_the_end_of_February')}</p>
                </td>
                <td>
                  <p>{t('features.YearEndReports.YearEndReport.you_can_check_your_payroll_and_allowances_paid_from_jan_1st_to_dec_31st')}</p>
                </td>
              </tr>
              <tr>
                <td className={styles.category} rowSpan={1}>
                  {t('features.YearEndReports.YearEndReport.document_for_employees')}
                </td>
                <td className={styles.name}>
                  <a href={Urls.SHOW_WITHHOLDING_REPORT_PAGE_URL}>{t('features.YearEndReports.YearEndReport.50tawi')}</a>
                  <p>{t('features.YearEndReports.YearEndReport.the_amount_of_salary_and_other_payments_made_during_the_year_and_income_taxes_paid')}</p>
                </td>
                <td className={styles.limit}>{t('features.YearEndReports.YearEndReport.before_end_of_March')}</td>
                <td>
                  <p>{t('features.YearEndReports.YearEndReport.you_can_check_the_amount_of_payroll_and_income_tax_paid_from_jan_1st_to_dec_31st')}</p>
                </td>
              </tr> */}
            </tbody>
          </table>
        </div>
      </div>
    </React.Fragment>
  );
};

export default compose(withSetupNeeded('to_start_year_end_section'), connect())(YearEndReport);
